import React, { useEffect, useRef, useState } from 'react';

const StatsTrustBar = () => {
  const sectionRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  const stats = [
    { value: '100%', label: 'Cert III Qualified' },
    { value: 'NPAAC', label: 'Compliant Transport' },
    { value: 'All Labs', label: 'Accepted' },
    { value: '3 Cities', label: 'Metro Coverage' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            entry.target.querySelectorAll('.fade-up').forEach((el, index) => {
              setTimeout(() => { el.classList.add('visible'); }, index * 100);
            });
          }
        });
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    /* Mint-tinted band — creates rhythm between Services (white) and Why Nura (off-white) */
    <section
      ref={sectionRef}
      className="py-14 relative overflow-hidden"
      style={{
        background: '#EEFAF6',
        borderTop: '1px solid rgba(128,229,203,0.40)',
        borderBottom: '1px solid rgba(128,229,203,0.40)',
      }}
    >
      <div className="container relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <div key={stat.label} className="fade-up text-center">
              {/* Mint accent dot above value */}
              <div
                className="w-2 h-2 rounded-full mx-auto mb-3"
                style={{ background: '#80E5CB' }}
              />
              <div
                className="font-bold text-3xl md:text-4xl mb-1"
                style={{
                  color: '#00001E',
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: '-0.02em',
                }}
              >
                {stat.value}
              </div>
              <div
                className="text-sm md:text-base font-medium"
                style={{
                  color: '#2B3879',
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  opacity: 0.80,
                }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsTrustBar;
